<template>
  <main class="content">
    <headerCustom :name="translation.NAME" :logo="translation.LOGO" :lang="language" @changeLang="changeLanguage"/>
    <section class="container-fluid p-0 main-section">
      <b-container fluid="xl" class="form-container">
        <transition name="fade-up" appear>
          <b-row no-gutters class="shadow-lg overflow-hidden card-container">
            <!-- Columna Izquierda: Contenido Motivador con SVGs -->
            <b-col cols="12" md="6" class="d-none d-md-block p-0">
              <div class="form__description">
                <div class="visual-elements">
                  <div class="svg-blob blob-1"></div>
                  <div class="svg-blob blob-2"></div>
                  <div class="svg-blob blob-3"></div>
                  <!-- Iconos Flotantes que representan valores para Signup (Más enfocados en crecimiento y rentabilidad) -->
                  <div class="floating-icons">
                    <!-- Crecimiento / Flecha arriba -->
                    <div class="f-icon icon-1">
                      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23 6L13.5 15.5L8.5 10.5L1 18" stroke="white" stroke-opacity="0.3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M17 6H23V12" stroke="white" stroke-opacity="0.3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    </div>
                    <!-- Rentabilidad / Diamante/Valor -->
                    <div class="f-icon icon-2">
                      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 3L3 8L12 21L21 8L18 3H6Z" stroke="white" stroke-opacity="0.3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    </div>
                    <!-- Rapidez / Rayo -->
                    <div class="f-icon icon-3">
                      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" stroke="white" stroke-opacity="0.3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    </div>
                    <!-- Éxito / Trofeo -->
                    <div class="f-icon icon-4">
                      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6m12 5h1.5a2.5 2.5 0 0 0 0-5H18M8 22h8M12 15V22M7 4h10v11c0 2.76-2.24 5-5 5s-5-2.24-5-5V4Z" stroke="white" stroke-opacity="0.3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    </div>
                  </div>
                </div>
                <div class="description-content">
                  <img :src="translation.LOGO" alt="Logo" class="mb-4 brand-logo">
                  <h2 class="text-white font-weight-bold mb-3">{{ translation[language].title }}</h2>
                  <p class="text-white description-text" v-html="translation[language].description"></p>
                  <div v-if="translation[language].benefits && translation[language].benefits.length" class="benefits-mini mt-5">
                    <div v-for="(benefit, index) in translation[language].benefits" :key="index" class="benefit-item">
                      <div class="icon-wrap">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
                      </div>
                      <span>{{ benefit.label }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
            <!-- Columna Derecha: Formulario de Signup -->
            <b-col cols="12" md="6" class="p-0">
              <div class="form__content">
                <div class="text-center mb-4">
                  <h1 class="login-title">{{title[language]}}</h1>
                  <div class="title-underline"></div>
                </div>

                <div class="login-buttons-container">
                  <ButtonGoogleLogin id="google-button" v-if="translation.AUTH['GOOGLE']" type="SIGNUP" :lang="language" variant="outline-gray" class="social-button" />
                  <b-tooltip target="google-button" variant="warning">
                    {{tooltip.GOOGLE[language]}}
                  </b-tooltip>
                  <ButtonMicrosoftLogin v-if="translation.AUTH['MICROSOFT']" type="SIGNUP" :lang="language" variant="outline-gray" class="social-button" />
                  <ButtonLinkedInLogin v-if="translation.AUTH['LINKEDIN']" type="SIGNUP" :lang="language" variant="outline-gray" class="social-button" />
                  <ButtonEmailVerification id="otp-button" v-if="translation.AUTH['OTP']" type="SIGNUP" :lang="language"  variant="outline-gray" :channel="2" class="otp-button" />
                  <b-tooltip target="otp-button" variant="warning" placement="bottom">
                    {{tooltip.OTP[language]}}
                  </b-tooltip>
                </div>

                <p class="policy-text mt-4">{{policy[language]}}</p>

                <div class="signup-section border-top pt-4 mt-4 text-center">
                  <p class="motivation-text mb-3">{{motivation_access_account[language]}}</p>
                  <div class="login-buttons-container">
                    <ButtonComponent
                      icon="arrow-right-circle-fill"
                      iconPosition="end"
                      :text="access_account[language]"
                      variant="orange"
                      href="/login"
                      class="mt-0 signup-button"
                    />
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </transition>
      </b-container>
    </section>
    <footerCustom :lang="language" />
  </main>
</template>

<script>
import headerCustom from '../components/header.vue'
import footerCustom from '../components/footer.vue'
import ButtonEmailVerification from '@/packages/systemico.ui/components/buttons/ButtonEmailVerification.vue'
import ButtonGoogleLogin from '@/packages/systemico.ui/components/buttons/ButtonGoogleLogin.vue'
import ButtonLinkedInLogin from '@/packages/systemico.ui/components/buttons/ButtonLinkedInLogin.vue'
import ButtonMicrosoftLogin from '@/packages/systemico.ui/components/buttons/ButtonMicrosoftLogin.vue'
import ButtonComponent from '@/packages/systemico.ui/components/buttons/ButtonComponent.vue'
import json from '../../../../lang/signup.json'
export default {
  name: 'SignupView',
  components: {
    ButtonComponent,
    ButtonMicrosoftLogin,
    ButtonLinkedInLogin,
    ButtonGoogleLogin,
    ButtonEmailVerification,
    headerCustom,
    footerCustom
  },
  props: {
    lang: {
      type: String,
      default: 'EN'
    }
  },
  data: function () {
    return {
      translation: json,
      language: 'EN',
      option: 0,
      options: [
        {
          title: 'Automatización de marketing.',
          text: 'Envia diaria, semanal, mensual o anual notificaciones de recordatorio para adquisición o renovación de servicios.'
        },
        {
          title: 'Analiza sitios web automáticamente.',
          text: 'Genera bases de datos automáticas a partir de la información pública de clientes potenciales.'
        },
        {
          title: 'Establece metas de impacto.',
          text: 'Envia notificaciones diarias limitadas para validar horarios, aperturas y cumplimiento de tu objetivo.'
        },
        {
          title: 'Define Eventos.',
          text: 'Parametriza eventos para realizar acciones de llamadas, notificaciones u otros cuando un cliente cumpla una etapa de tu proceso de marketing.'
        }
      ],
      title: {
        EN: 'Create your account',
        ES: 'Crea tu cuenta',
        PT: 'Crie sua conta',
        FR: 'Créez votre compte'
      },
      policy: {
        ES: 'Cuando creas o accedes a tu cuenta aceptas nuestras políticas y términos.',
        EN: 'When you create an account you accept our policies and terms.',
        PT: 'Ao criar ou acessar sua conta, você aceita nossas políticas e termos.',
        FR: 'En créant ou en accédant à votre compte, vous acceptez nos politiques et conditions.'
      },
      motivation_access_account: {
        ES: '¿Ya tienes una cuenta?',
        EN: 'Do you have an account?',
        PT: 'Já tem uma conta?',
        FR: 'Avez-vous déjà un compte ?'
      },
      access_account: {
        ES: 'Ingresa a tu cuenta.',
        EN: 'Access your account.',
        PT: 'Acesse sua conta.',
        FR: 'Accédez à votre compte.'
      },
      tooltip: {
        GOOGLE: {
          ES: 'Crea tu cuenta con Google',
          EN: 'Create your account with Google',
          PT: 'Crie sua conta com o Google',
          FR: 'Créez votre compte avec Google'
        },
        OTP: {
          ES: 'Crea tu cuenta con cualquier email y una contraseña temporal que te enviamos a tu email.',
          EN: 'Create your account with any email and a temporary password that we send to your email.',
          PT: 'Crie sua conta com qualquer e-mail e uma senha temporária que enviamos para seu e-mail.',
          FR: 'Créez votre compte avec n\'importe quel e-mail et un mot de passe temporaire que nous envoyons sur votre e-mail.'
        }
      }
    }
  },
  mounted () {
    this.autoChangeOption()
  },
  beforeMount () {
    this.language = this.lang
  },
  methods: {
    changeOption (option) {
      this.option = option
    },
    changeLanguage (lang) {
      this.language = lang
      this.options = this.translation[this.language].options
    },
    autoChangeOption () {
      setTimeout(() => {
        if (this.option === 3) {
          const option = 0
          this.option = option
          this.autoChangeOption()
        } else {
          const option = this.option + 1
          this.option = option
          this.autoChangeOption()
        }
      }, 5000)
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  height: 100vh;
  min-height: 600px;
  background-color: #f8f9fc;
  background-image:
    radial-gradient(at 0% 0%, hsla(21, 100%, 58%, 0.05) 0px, transparent 50%),
    radial-gradient(at 100% 0%, hsla(232, 50%, 18%, 0.05) 0px, transparent 50%),
    radial-gradient(at 100% 100%, hsla(212, 100%, 47%, 0.05) 0px, transparent 50%),
    radial-gradient(at 0% 100%, hsla(232, 50%, 18%, 0.05) 0px, transparent 50%),
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 80 80'%3E%3Cg fill='%239C92AC' fill-opacity='0.03'%3E%3Cpath d='M0 0h40v40H0V0zm40 40h40v40H40V40zm0-40h2V2h-2V0zm0 4h2v2h-2V4zm0 4h2v2h-2V8zm0 4h2v2h-2v-2zm0 4h2v2h-2v-2zm0 4h2v2h-2v-2zm0 4h2v2h-2v-2zm0 4h2v2h-2v-2zm0 4h2v2h-2v-2zm0 4h2v2h-2v-2zm0 4h2v2h-2v-2zm0 4h2v2h-2v-2zm0 4h2v2h-2v-2zm0 4h2v2h-2v-2zm2-2h2v2h-2v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2zm-38 0h2v2h-2v-2zm-4 0h2v2h-2v-2zm-4 0h2v2h-2v-2zm-4 0h2v2h-2v-2zm-4 0h2v2h-2v-2zm-4 0h2v2h-2v-2zm-4 0h2v2h-2v-2zm-4 0h2v2h-2v-2zm-4 0h2v2h-2v-2zm-4 0h2v2h-2v-2zm-4 0h2v2h-2v-2zm-4 0h2v2h-2v-2zm-4 0h2v2h-2v-2zm-4 0h2v2h-2v-2z'/%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  font-family: "Quicksand", sans-serif;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  &__section {
    padding: 30px 20px;
  }
  &__link {
    margin: 0;
    font-family: "Mulish", sans-serif;
    font-size: 14px;
    font-weight: normal;
    color: #4285f4;
    img {
      margin-right: 10px;
    }
  }
  &__options {
    a {
      margin: 10px 0;
      font-size:12px;
      text-align: center;
      display: block;
    }
  }
}

.main-section {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.form-container {
  padding: 0;
  max-width: 900px;
  perspective: 1000px;
}

.card-container {
  background: white;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 24px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }
}

.form__description {
  height: 100%;
  min-height: 550px;
  background: linear-gradient(135deg, #ff8028 0%, #e66a10 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  position: relative;
  overflow: hidden;
  transition: all 0.5s ease;

  .visual-elements {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;

    .svg-blob {
      position: absolute;
      background: rgba(255, 255, 255, 0.2);
      filter: blur(40px);
      border-radius: 50%;
    }

    .blob-1 {
      width: 300px;
      height: 300px;
      top: -100px;
      right: -100px;
      background: rgba(255, 255, 255, 0.15);
    }

    .blob-2 {
      width: 200px;
      height: 200px;
      bottom: -50px;
      left: -50px;
      background: rgba(23, 30, 68, 0.2);
    }

    .blob-3 {
      width: 150px;
      height: 150px;
      top: 40%;
      right: 10%;
      background: rgba(255, 255, 255, 0.1);
    }

    .floating-icons {
      position: absolute;
      width: 100%;
      height: 100%;

      .f-icon {
        position: absolute;
        width: 80px;
        height: 80px;
        opacity: 0.5;
        animation: float 6s ease-in-out infinite;

        svg {
          width: 100%;
          height: 100%;
        }
      }

      .icon-1 { top: 15%; left: 15%; animation-delay: 0s; }
      .icon-2 { top: 20%; right: 15%; animation-delay: 2s; }
      .icon-3 { bottom: 20%; left: 20%; animation-delay: 4s; }
      .icon-4 { bottom: 15%; right: 20%; animation-delay: 1s; }
    }
  }

  @keyframes float {
    0%, 100% { transform: translateY(0) rotate(0); }
    50% { transform: translateY(-20px) rotate(10deg); }
  }

  .description-content {
    position: relative;
    z-index: 1;
    text-align: center;

    .brand-logo {
      height: 70px;
      filter: drop-shadow(0 4px 6px rgba(0,0,0,0.1));
    }

    .description-text {
      font-size: 1.1rem;
      line-height: 1.6;
    }

    .benefits-mini {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 12px;

      .benefit-item {
        display: flex;
        align-items: center;
        gap: 10px;
        color: white;
        font-weight: 600;
        font-size: 0.9rem;
        background: rgba(255, 255, 255, 0.15);
        padding: 8px 20px;
        border-radius: 50px;
        border: 1px solid rgba(255, 255, 255, 0.2);
        backdrop-filter: blur(5px);

        .icon-wrap {
          color: white;
          display: flex;
        }
      }
    }
  }
}

.form__content {
  padding: 50px 40px;
  background: white;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .login-title {
    font-size: 1.75rem;
    font-weight: 800;
    color: #171e44;
    margin-bottom: 0.5rem;
    letter-spacing: -0.025em;
    text-align: center;
  }

  .title-underline {
    width: 40px;
    height: 4px;
    background-color: #ff8028;
    margin: 0 auto;
    border-radius: 2px;
  }
}

.policy-text {
  font-size: 0.75rem;
  color: #94a3b8;
  text-align: center;
  line-height: 1.5;
  max-width: 280px;
  margin: 0 auto;
}

.signup-section {
  .motivation-text {
    font-size: 0.95rem;
    color: #475569;
    font-weight: 600;
  }

  .signup-button {
    ::v-deep button {
      border-radius: 12px;
      font-weight: 700;
      padding: 12px;
    }
  }
}

.login-buttons-container {
  max-width: 340px;
  margin: 0 auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  & > * {
    width: 100%;
    margin-bottom: 1.25rem;
    display: block;
    transition: transform 0.2s ease;

    &:hover {
      transform: translateY(-2px);
    }
  }

  .social-button {
    ::v-deep button {
      border-radius: 12px;
      font-weight: 600;
      padding: 12px;
    }
  }

  .otp-button {
    ::v-deep button {
      border-radius: 12px;
      font-weight: 600;
      padding: 12px;
    }
  }

  ::v-deep .button-component {
    width: 100%;
  }
}

/* Animations */
.fade-up-enter-active, .fade-up-leave-active {
  transition: opacity 0.6s cubic-bezier(0.16, 1, 0.3, 1), transform 0.6s cubic-bezier(0.16, 1, 0.3, 1);
}
.fade-up-enter {
  opacity: 0;
  transform: translateY(20px);
}

@media (max-width: 767.98px) {
  .content {
    height: auto;
    min-height: 100vh;
    overflow: auto;
    padding-bottom: 80px;
  }
}
</style>
